// Main entry point for the Pokedex scene
import PokedexScene from './PokedexScene';

// Export the PokedexScene as the default export
export default PokedexScene;